import API from "@/api/lib/api";

export const getAllSauces = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/sauces/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleSauceById = async (id) => {
  try {
    const response = await API.get(`restaurant/sauces/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createSauce = async (data) => {
  try {
    const response = await API.post(`restaurant/sauces`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateSauce = async (id, data) => {
  try {
    const response = await API.put(`restaurant/sauces/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteSauce = async (id) => {
  try {
    const response = await API.delete(`restaurant/sauces/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};